import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import './footer.css';

const Footer = () => {
  const navigate = useNavigate(); // Initialize the hook

  // Handler function to navigate programmatically


  const handleNavigation = (path) => {
    navigate(path); // Navigate to the path
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 0); // Smooth scroll to the top
  };

  return (
    <>
      {/* Add a white/light grey space before the footer */}
      <div className="footer-space"></div>

      <footer className="footer">
        <div className="footer-container">
          {/* Footer Column 1 */}
          <div className="footer-column">
            <h3>Innit</h3>
            <p>
              Connecting individuals to Innit solutions with expert care and tailored guidance.
            </p>
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>

              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>

              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>

              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>

            </div>
          </div>

          {/* Footer Column 2 */}
          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li>
                <button onClick={() => handleNavigation('/about-us')}>
                  About
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/services')}>
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/careers')}>
                  Careers
                </button>
              </li>
            </ul>
          </div>

          {/* Footer Column 3 */}
          <div className="footer-column">
            <h3>Help</h3>
            <ul>
              <li>
                <button onClick={() => handleNavigation('/contact')}>
                  Contact
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/terms')}>
                  Terms & Conditions
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/privacy-policy')}>
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© Copyright 2025, All Rights Reserved</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
